import { classTranslations } from '../modules/class/i18n';
import { courseTranslations } from '../modules/course/i18n';
import { pollTranslations } from '../modules/poll/i18n';
import { sharedTranslations } from '../modules/shared/i18n';
import { timerTranslations } from '../modules/timer/i18n';
import { authTranslations } from '../modules/auth/i18n';
import { homeTranslations } from '../pages/home/i18n';
import { commonTranslations } from './common';
import { glossaryTranslations } from './glossary';
import { validationTranslations } from './validation';
import { restrictedTranslations } from '../modules/restricted/i18n';
import Logger from '../utils/logger';

export enum i18nNS {
  COMMON = 'common',
  SHARED = 'shared',
  GLOSSARY = 'glossary',
  VALIDATION = 'validation',
  AUTH = 'auth',
  HOME = 'home',
  RESTRICTED = 'restricted',
  COURSE = 'course',
  CLASS = 'class',
  POLL = 'poll',
  TIMER = 'timer',
}

export const defaultNS = i18nNS.SHARED;

export const enLang = {
  [i18nNS.COMMON]: commonTranslations['en'],
  [i18nNS.SHARED]: sharedTranslations['en'],
  [i18nNS.GLOSSARY]: glossaryTranslations['en'],
  [i18nNS.VALIDATION]: validationTranslations['en'],
  [i18nNS.AUTH]: authTranslations['en'],
  [i18nNS.HOME]: homeTranslations['en'],
  [i18nNS.RESTRICTED]: restrictedTranslations['en'],
  [i18nNS.COURSE]: courseTranslations['en'],
  [i18nNS.CLASS]: classTranslations['en'],
  [i18nNS.POLL]: pollTranslations['en'],
  [i18nNS.TIMER]: timerTranslations['en'],
};

export function checkDuplicateTranslationKeys(englishResources: typeof enLang) {
  const enResources = Object.entries(englishResources);
  const allTranslations: Record<string, Set<string>> = {};

  for (const [namespace, translations] of enResources) {
    for (const translationKey in translations) {
      if (allTranslations[translationKey]) {
        allTranslations[translationKey].add(namespace);
      } else {
        allTranslations[translationKey] = new Set([namespace]);
      }
    }
  }

  for (const translationKey in allTranslations) {
    const namespaces = allTranslations[translationKey];
    if (namespaces.size > 1) {
      Logger.warn(
        `Duplicate translations found for key \`${translationKey}\` in namespaces \`[${Array.from(namespaces)}]\``
      );
    }
  }
}
